'use client';

import type { FC, HTMLAttributes } from 'react';
import { cardVariants, titleVariants } from '@paypoteam/ui-components';

import { cn } from '@/lib/utils';
import { mapFreshdeskCategoriesIcons } from '@/utils/mapFreshdeskCategoriesIcons';

import type { CategoryType } from '@/app/(website)/(pl)/p/(mainLayout)/kontakt/hooks/useSearch';

export interface CategoriesCardTemplateProps extends HTMLAttributes<Element> {
    id: string;
    name: string;
    onCategorySelect?: ({ id, name }: CategoryType) => void;
}

const CategoriesCardTemplate: FC<CategoriesCardTemplateProps> = ({
    id,
    name,
    onCategorySelect,
    className,
    ...cardProps
}) => {
    const Tag = onCategorySelect ? 'button' : 'div';
    const Icon = mapFreshdeskCategoriesIcons(name);

    return (
        <Tag
            {...cardProps}
            className={cn(
                cardVariants({ variant: 'shadow', size: 'm' }),
                'flex min-h-[100px] w-full cursor-pointer flex-row items-center justify-between transition-all duration-300 hover:shadow-lg sm:min-h-[120px] xl:min-h-[100px]',
                className,
            )}
            onClick={() => {
                !!onCategorySelect && onCategorySelect({ id, name });
            }}
        >
            <Icon
                alt=""
                size={32}
            />

            <span
                className={cn(
                    titleVariants({ size: 's' }),
                    'ml-4 flex-1 text-left',
                )}
            >
                {name}
            </span>
        </Tag>
    );
};

export default CategoriesCardTemplate;
